import { render } from "./NavDrawer.vue?vue&type=template&id=0c8db82a&scoped=true"
import script from "./NavDrawer.vue?vue&type=script&lang=js"
export * from "./NavDrawer.vue?vue&type=script&lang=js"

import "./NavDrawer.vue?vue&type=style&index=0&id=0c8db82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8db82a"]])

export default __exports__